module.exports = __webpack_public_path__ + "static/media/evolution-image-desktop.b23d3095.png";